import { createContext, CSSProperties, ReactNode, useContext } from 'react';

export type WhilelabelContextType = {
  companyName?: string;
  pixelName?: string;
  primaryColor?: string;
  companyLogo?: ReactNode;
  primaryButtonStyle?: CSSProperties;
  secondaryButtonStyle?: CSSProperties;
  isWhitelabelCompany?: boolean;
  supportEmail?: string;
};

export const WhitelabelContext = createContext({} as WhilelabelContextType);

export const useWhitelabelConfig = () => useContext(WhitelabelContext);
